<template>
  <div class="science">
    <div class="head-img">
      <p>前沿学术推广&ensp;&ensp;基层人才培养</p>
    </div>
    <!-- 菜单 -->
    <div class="science-menu">
      <div class="menu-head">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item>医学培训</el-breadcrumb-item>
          <el-breadcrumb-item>{{BreadText}}</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="gundong">
        <ul class="menu-content">
          <li v-for="item in scienceMenu" :key="item.id" :class="inRouter == item.name?'innovate-gl':''">
            <router-link :to="{name:item.name}" @click="toRouter(item.name)">{{item.text}}
            </router-link>
          </li>
        </ul>
      </div>
    </div>
    <transition enter-active-class="animate__animated animate__fadeIn">
      <router-view />
    </transition>

  </div>
</template>

<script>

export default {
  data() {
    return {
      scienceMenu: [
        {
          id: 1,
          text: '专项培训',
          name: 'zhuanxiang'
        },
        {
          id: 2,
          text: '教学直播',
          name: 'jiaoxue'
        },
        {
          id: 3,
          text: '学术推广',
          name: 'xueshu'
        },
        {
          id: 4,
          text: '透析技能竞赛',
          name: 'jineng'
        },
        {
          id: 5,
          text: '病例征集',
          name: 'bingli'
        },
      ],
      inRouter: this.$router.history.current.name,
      BreadText: this.$router.history.current.meta.title || '',
    }
  },

  watch: {
    $route(to) {
      let newpath = to.path.slice(1).split('/')[1]
      this.ishow = !this.ishow
      this.inRouter = newpath
      let MybreadText = this.scienceMenu.filter(item => {
        return item.name == newpath
      })
      this.BreadText = MybreadText[0].text
    }
  },
  created() {

  },
  mounted() {
  },
  methods: {
  }
}
</script>

<style scoped lang="scss">
.science {
  .head-img {
    height: 5.2632rem;
    background: url('https://yyt-ows.oss-cn-beijing.aliyuncs.com/804FEDA056FF4A1394EE85E0A0383089-6-2.png') no-repeat;
    background-size: 100% 100%;
    display: flex;
    justify-content: center;
    @media screen and (max-width: 540px) {
      height: 250px;
      background-size: cover;
      background-position: 50% 0;
    }
    align-items: center;
    p {
      color: #ffffff;
      font-weight: 700;
      font-size: 0.4632rem;
      @media screen and (max-width: 540px) {
        font-size: 22px;
      }
    }
  }
  .science-menu {
    height: 1.1789rem;
    margin: 0 0.8421rem;
    position: relative;
    display: flex;
    justify-content: space-between;
    // justify-content: center;
    padding: 0 0.6316rem;
    align-items: center;
    @media screen and (max-width: 540px) {
      margin: 0;
      height: 56px;
    }
    .menu-head {
      padding-right: 2.6316rem;
      width: 2.6316rem;
      font-size: 0.2105rem !important;
      @media screen and (max-width: 540px) {
        display: none;
      }
      .el-breadcrumb {
        font-size: 0.1895rem;
      }
    }
    .gundong::-webkit-scrollbar {
      display: none;
    }
    .gundong {
      height: 100%;
      @media screen and (max-width: 540px) {
        overflow: scroll;
        overflow-y: hidden;
      }
      .menu-content {
        display: flex;
        height: 100%;
        li {
          display: flex;
          align-items: center;
          height: 100%;
          padding: 0 0.4737rem;
          font-size: 0.2105rem;
          box-sizing: border-box;
          border-bottom: 6px solid #0ca4eb00;
          @media screen and (max-width: 540px) {
            font-size: 15px;
            margin: 0 15px;
          }
          a {
            font-weight: 700;
            list-style: none;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            color: #666666;
          }
        }
      }
    }
    // 菜单高亮
    .innovate-gl {
      // padding: 0.4737rem 0 0.3789rem 0;
      border-bottom-color: #0ca6eb !important;
      z-index: 999;
      a {
        color: #0ca6eb !important;
      }
    }
  }
  .science-menu::after {
    position: absolute;
    content: '';
    bottom: 0;
    left: 0;
    height: 6px;
    width: 100%;
    border-radius: 0.0316rem;
    background-color: #f1f1f1;
  }
}
</style>
